import React from 'react';
import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';

/**
 * Shared error alert component for failed requests
 * @param {Object} props - Component props
 * @param {Error} props.error - Error object from failed request
 * @param {string} props.message - Custom error message key
 */
const ErrorState = ({ error, message }) => {
  const { t } = useTranslation('common');

  return (
    <Alert
      message={message ? t(message) : t('error_loading_results')}
      description={error?.message}
      type="error"
      showIcon
    />
  );
};

export default ErrorState;